#import "../fragments/contact-page-fragment.graphql"

mutation UpdateContact($input: ContactUpdateInput!) {
    contactUpdate(input: $input) {
        contact {
            ...ContactPageFragment
        }
    }
}
